/**
 * ⚠️ AUTO-GENERATED FILE - DO NOT EDIT
 *
 * Generated by: sf database-code
 * Generated from database schema
 *
 * To modify: Change the database schema and re-run `sf database-code` (dc). To make a column queryable by index — including boolean/nullable columns — add a single-column Postgres index and re-run `sf dc`; do not hand-edit generated files.
 */

import { isObject, hasPropOfType, UUID, Temporal, type LocalDatabaseTableDefinition } from 'sf-shared';
import type { ShoppedItemBase } from 'shared/dbo/ShoppedItem';

export interface ShoppedItemIndexedDb {
	id: string;
	shoppingDate: string;
	storeProductId: string;
	quantity: number;
	shopped?: number;
	created: number;
	lastModified: number;
	shortId: string;
}

export const isShoppedItemIndexedDb = (obj: unknown): obj is ShoppedItemIndexedDb => {
	if (!isObject(obj)) {
		return false;
	}
	if (hasPropOfType<{ deleted: boolean }>(obj, 'deleted', 'boolean') && obj.deleted) {
		return true;
	}
	if (!hasPropOfType<{ id: unknown }>(obj, 'id') || !(typeof obj.id === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ shoppingDate: unknown }>(obj, 'shoppingDate') || !(typeof obj.shoppingDate === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ storeProductId: unknown }>(obj, 'storeProductId') || !(typeof obj.storeProductId === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ quantity: unknown }>(obj, 'quantity') || !(typeof obj.quantity === 'number')) {
		return false;
	}
	if (hasPropOfType<{ shopped: unknown }>(obj, 'shopped') && !(typeof obj.shopped === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ created: unknown }>(obj, 'created') || !(typeof obj.created === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ lastModified: unknown }>(obj, 'lastModified') || !(typeof obj.lastModified === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ shortId: unknown }>(obj, 'shortId') || !(typeof obj.shortId === 'string')) {
		return false;
	}
	return true;
};

export const baseToIndexedDB = (obj: ShoppedItemBase): ShoppedItemIndexedDb => ({
	id: obj.id.toString(),
	shoppingDate: obj.shoppingDate.toString(),
	storeProductId: obj.storeProductId.toString(),
	quantity: Number(obj.quantity),
	// prettier-ignore
	// eslint-disable-next-line no-eq-null, eqeqeq -- generated: intentional null|undefined (== null) runtime check for the nullable cache form; see #129
	shopped: obj.shopped == null ? undefined : obj.shopped.epochMilliseconds,
	created: obj.created.epochMilliseconds,
	lastModified: obj.lastModified.epochMilliseconds,
	shortId: obj.id.shortString,
});

export const indexedDBToBase = (obj: ShoppedItemIndexedDb): ShoppedItemBase => ({
	id: UUID.fromString(obj.id),
	shoppingDate: Temporal.PlainDate.from(obj.shoppingDate),
	storeProductId: UUID.fromString(obj.storeProductId),
	quantity: BigInt(obj.quantity),
	// prettier-ignore
	// eslint-disable-next-line no-eq-null, eqeqeq -- generated: intentional null|undefined (== null) runtime check for the nullable cache form; see #129
	shopped: obj.shopped == null ? undefined : Temporal.Instant.fromEpochMilliseconds(obj.shopped),
	created: Temporal.Instant.fromEpochMilliseconds(obj.created),
	lastModified: Temporal.Instant.fromEpochMilliseconds(obj.lastModified),
	objectContext: 'db',
});

export const itdShoppedItem: LocalDatabaseTableDefinition<ShoppedItemBase, ShoppedItemIndexedDb> = {
	tableName: 'shoppedItems',
	indexColumns: ['shoppingDate', 'storeProductId'],
	convertToIndexed: baseToIndexedDB,
	convertFromIndexed: indexedDBToBase,
};
